/**
 * Keep localStorage.isNotAcademy in sync with the current branch / pending order.
 * Used by order-summary wall promo (non-academic branches hide the share UI).
 */

export function setIsNotAcademyLocalStorage(isNotAcademy: boolean): void {
  try {
    localStorage.setItem('isNotAcademy', String(!!isNotAcademy));
  } catch {
    /* ignore */
  }
}

/** Cluster / realBranch shape from getAllBranches / printing-table */
export function resolveIsNotAcademyFromCluster(
  cluster: any,
  printingService: string
): boolean {
  if (!cluster || !printingService) {
    return false;
  }
  if (printingService === 'express') {
    return !!cluster?.express?.properties?.isNotAcademy;
  }
  if (printingService === 'plotter') {
    return !!(cluster?.isNotAcademy || cluster?.plotter?.isNotAcademy);
  }
  return false;
}

/** Pending / my-orders order with populated branchID / printerID */
export function resolveIsNotAcademyFromOrder(
  order: any,
  printingService: string
): boolean {
  if (!order || !printingService) {
    return false;
  }
  const service = printingService === 'p' ? 'plotter'
    : printingService === 'e' ? 'express'
    : printingService;
  if (service === 'express') {
    return !!order?.printerID?.properties?.isNotAcademy;
  }
  if (service === 'plotter') {
    return !!(order?.branchID?.isNotAcademy);
  }
  return false;
}

export function syncIsNotAcademyFromCluster(
  cluster: any,
  printingService: string
): void {
  setIsNotAcademyLocalStorage(
    resolveIsNotAcademyFromCluster(cluster, printingService)
  );
}

export function syncIsNotAcademyFromOrder(
  order: any,
  printingService: string
): void {
  setIsNotAcademyLocalStorage(
    resolveIsNotAcademyFromOrder(order, printingService)
  );
}
